import axios from 'axios';

const URL = 'https://league.iesdev.com/api';
const instance = axios.create({ timeout: 10000, baseURL: URL });

instance.interceptors.request.use((config) => {
  if (config.debug) console.log(`\n(${config.method.toUpperCase()}) ${config.url} ${JSON.stringify(config.params)}`);
  return config;
}, (error) => {
  return Promise.reject(error);
});

class LeagueAPI {
  getTournaments(tournamentId) {
    return instance.get(`/tournaments/${tournamentId}/`);
  }
  getMatches(params) {
    return instance.get('/matches/', { params });
  }
  getMatch(matchId) {
    return instance.get(`/matches/${matchId}/`);
  }
  getGame(gameId) {
    return instance.get(`/games/${gameId}/`);
  }
  getTeam(id) {
    return instance.get(`/teams/${id}/`);
  }
  getPlayer(id) {
    return instance.get(`/players/${id}`);
  }
  getTeamStats(id) {
    return instance.get(`/stats/teams/${id}/`);
  }
  getPlayerStats(id, params) {
    return instance.get(`/stats/players/${id}/`, { params });
  }
  getGamePlayers(params) {
    return instance.get('/games/gameplayers/', { params });
  }

  getPlayerAutocomplete(params) {
    return instance.get('/autocomplete/players', { params });
  }

  getTeamAutocomplete(params) {
    return instance.get('/autocomplete/teams', { params });
  }

  getTournamentAutocomplete(params) {
    return instance.get('/autocomplete/tournaments', { params });
  }

  getSeriesAutocomplete(params) {
    return instance.get('/autocomplete/series', { params });
  }
}
export default new LeagueAPI();



// WEBPACK FOOTER //
// ./src/api/LeagueAPI.js